import { render, staticRenderFns } from "./VideosListItem.vue?vue&type=template&id=d29cd5f2&"
import script from "./VideosListItem.vue?vue&type=script&lang=js&"
export * from "./VideosListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports